import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { useSignoutMutation } from "../../store/apis/authApi";
import { errorMsg, successMsg } from "../../constants/msgs";
import { EmptyLocalStorage } from "../../utils/helper";
import ThemeSpinner from "../general/ThemeSpinner";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/services/authInfo";
import { useForm } from "react-hook-form";
import { useUpdateFaqsMutation } from "../../store/apis/faqApi";
import ThemeInput from "../input/ThemeInput";
import { uniqueId } from "lodash";
import { useSendCoinMutation } from "../../store/apis/userApi";

const SendCoinModal = ({ isOpen, handleCoinsModalClose, selectedData, refetch }) => {
    // console.log("selectedData", selectedData);
    const { register, reset, control, handleSubmit, watch, formState: { errors } } = useForm({ mode: 'onChange' })

    const navigate = useNavigate();
    const [sendCoinApi, { isLoading }] = useSendCoinMutation()


    const onSubmit = async (formData) => {
        console.log(formData);
        console.log(selectedData?.slug);
        const { data, error } = await sendCoinApi({ data: formData, slug: selectedData?.slug }).unwrap();
        // console.log("data", data);
        // console.log("error", error);
        if (data) {
            successMsg(data?.message)
            refetch()
            handleCoinsModalClose()
            reset()
        } else {
            errorMsg(error?.data?.message)
        }
    }

    return (
        <Modal
            className="theme-modal logout-modal"
            show={isOpen}
            onHide={() => handleCoinsModalClose()}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <header className="header d-flex align-items-center justify-content-between">
                <h3 className="text-black fw-700">Send Coins</h3>
                <div className="box cursor" onClick={() => handleCoinsModalClose()}>
                    <FaTimes />
                </div>
            </header>

            <Modal.Body>
                <div key={uniqueId("modal")}>
                    {/* <h6 className="mb-4">Are you sure you want to logout ?</h6> */}

                    <Form onSubmit={handleSubmit(onSubmit)}>

                        <ThemeInput
                            name='coins'
                            control={control}
                            errors={errors}
                            rules={{
                                required: {
                                    value: true,
                                    message: "Coins are required"
                                }
                            }}
                            label="Coins"
                            placeholder="Enter coins number"
                            type="number"
                        />

                        <Button className="btn-solid btn-purple w-100" type="submit">
                            {isLoading ? <ThemeSpinner /> : "Send Coins"}
                        </Button>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SendCoinModal;
